// Vendors
import { CountriesLocaleEnum, StorageLocalEnum } from '@openbank/cf-ui-static-data';

const getBrowserOrSavedLanguage = (): string =>
  localStorage.getItem(StorageLocalEnum.LOCALE) || CountriesLocaleEnum.ENGLAND;

export { getBrowserOrSavedLanguage };
